import { dateColumn, primaryRelationshipColumn, roleColumn } from "./columnHelpers";
import { objectDefinition } from "./supportedObjects";

const {pluralName, color, endpoint} = objectDefinition('workplan');

export const workplansRelationship = {
    collapsible: true,
    title: pluralName,
    tint: color,
    type: 'table',
    columns: [
        primaryRelationshipColumn({endpoint}),
        dateColumn({
            column: 'workplan_date',
            className: 'min',
            visibleOnEdit: false,
        }),
    ],
};
